<template>
  <div class="coursemanagement">
    <div class="header">
      <el-input v-model="param.courseName" :placeholder="$t('Education.languages03')" clearable style="width: 200px;margin-right: 30px"></el-input>
      <el-button type="primary" @click="handleinitialization(1)">{{ $t('Education.languages01')}}</el-button>
      <el-button type="primary" @click="$refs.child.ClickADDCourse(0)">{{ $t('Education.languages02')}}</el-button>
    </div>

    <div class="content">
      <el-table
          v-loading="courseload"
          :data="CourseData"
          :cell-style="{'text-align':'center'}"
          :header-cell-style="{'text-align':'center'}"
          style="width: 100%">
        <el-table-column prop="courseName" label="课程"></el-table-column>
        <el-table-column prop="recentLiveTime" label="最近直播时间" :formatter="CreatexamChapterName"></el-table-column>
        <el-table-column prop="viewersnum" label="课程观看人次"></el-table-column>
        <el-table-column prop="playbacknum" label="课程回看次数"></el-table-column>
        <el-table-column prop="videos" label="视频数"></el-table-column>
        <el-table-column prop="hours" label="课时数"></el-table-column>
        <!-- <el-table-column prop="radioNum" label="单选题数"></el-table-column>
        <el-table-column prop="multipleNum" label="多选题数"></el-table-column>
        <el-table-column prop="questionNum" label="问答题数"></el-table-column>
        <el-table-column prop="examTitle" label="试卷标题"></el-table-column> -->
        <el-table-column label="操作">
          <template v-slot="scope">
            <span class="operateitem" @click="$refs.child.ClickADDCourse(1,scope.row)">{{ $t('Education.languages08')}}</span>
            <el-popconfirm
              @confirm="ClickDelete(scope.row)"
              title="是否确定删除？"
            >
              <span class="operateitem" slot="reference">{{ $t('Education.languages07')}}</span>
            </el-popconfirm>
            <span class="operateitem" @click="$router.push(`/Education/courseDetail?courseId=`+scope.row.courseId)">{{ $t('Education.languages09')}}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          class="pagination"
          :hide-on-single-page=true
          @current-change="handleinitialization"
          :current-page.sync="param.pageNum"
          :page-size="param.pageSize"
          layout="total, prev, pager, next"
          :total="param.PageTotal">
      </el-pagination>
    </div>
    <ADDCourse ref="child"></ADDCourse>
  </div>
</template>

<script>
import ADDCourse from './component/ADDCourse.vue'
export default ({
  name:'coursemanagement',
  data(){
    return{
      rules:{
        courseName:[
          {required: true, message:"请输入课程名", trigger: 'blur'}
        ],
        courseDescription:[
          {required: true, message:"请输入课程说明", trigger: 'blur'}
        ],
        courseCover:[{required: true, message:"请上传封面图", trigger: 'change'}]
      },
      actionUrl:process.env.VUE_APP_URL+'AppUser/UpdatePortraitAndCertificate',
      Authorization:sessionStorage.getItem('Authorization'),
      CourseData:[],
      courseload:false,
      param:{
        courseName:'',
        pageNum:1,
        pageSize:10,
        PageTotal:1,
      },
    }
  },
  created() {
    this.CourseList();
  },
  mounted() {
  },
  methods:{
    // 课程列表
    CourseList(){
      this.$Http_Post('edu/course/list',this.param).then(res=>{
        if(res.Code==0){
          this.CourseData=res.Data;
          this.param.PageTotal=res.Counts;
          this.courseload=false;
        }
      })
    },


    handleinitialization(val){
      this.courseload=true;
      this.param.pageNum=val;
      this.CourseList();
    },

    // 删除
    ClickDelete(e){
      this.$Http_Post(`edu/course/remove/${e.courseId}`).then(res=>{
        if(res.Code==0){
          this.CourseList();
          this.$message({
            type: 'success',
            message: res.Message,
          })
        }else{
          this.$message({type: 'error', message: res.Message})
        }
      });
    },
    CreatexamChapterName(row){
                return row.recentLiveTime?row.recentLiveTime:'暂无直播'
            }
  },
  components:{
    ADDCourse
  }
})
</script>
<style>
.coursemanagement .header{display: flex;align-items:center;background: #fff;padding:20px 30px;}
.coursemanagement .content{background:#fff;padding:30px;margin-top:20px;}
.operateitem{padding: 0 5px 0 0;color:#0088ff;cursor: pointer}
</style>